import { useOrganisationAcademicYearQuery } from '@/composable/queries/Dara/organisationAcademicYears'
import { useAuthStore } from '@/stores/auth'

export function useAcademicYearHelper() {
  const authStore = useAuthStore()

  const selectedOrganisationId = computed(() => authStore.selected_organisation_id ?? 0)

  const isOrganisationAcademicYearQueryEnabled = computed(() => {
    return (selectedOrganisationId.value != 0)
  })

  const { isPending: isPendingAcademicYears, data: academicYears } = useOrganisationAcademicYearQuery(
    selectedOrganisationId,
    isOrganisationAcademicYearQueryEnabled,
  )

  const getAcademicYearLabel = (academicYearId: number) => {
    if (!academicYears.value) return ''

    const academicYear = academicYears.value.find(a => a.id === academicYearId)

    return academicYear?.label
  }

  return {
    academicYears,
    getAcademicYearLabel,
    isPendingAcademicYears,
  }
}
